import * as Yup from "yup";

const validation = Yup.object().shape({
    name: Yup.string().max(100, "Max 100 caratteri").required("Obbligatorio"),
    manufacturer_id: Yup.number().required(),
    description: Yup.string().max(255, "Max 255 caratteri").notRequired(),
    note: Yup.string().notRequired()
})

const initialValues = {
    name: '',
    manufacturer_id: '',
    description: '',
    note: '',
}
export const vehicleForm = {
    validation,
    initialValues
}